/* Same Skies - collections/all interactions
 * Scoped to #ss-coll-all. Reads window.SSCollAllData (set by the section).
 * Behaviours:
 *   - filter chips (occasion) + live count + BYO placement (in-grid vs standalone)
 *   - personalisation teaser (flip tile front → cotton-card letter)
 *   - market toggle (AUD/GBP, persisted in localStorage 'ss-market')
 *   - BYO builder auto-cycle (tier → fill → review, 2.8s, paused on reduce-motion)
 *   - image fade-in / kraft fallback on error
 *   - "What's inside" opens the homepage drawers (snippets/ss-box-drawers,
 *     ss-comfort-boxes.js); the old quick-look was removed 2026-10-04
 */
(function () {
  'use strict';

  var root = document.getElementById('ss-coll-all');
  if (!root) return;

  var BYO_URL = (window.SSCollAllData && window.SSCollAllData.byoUrl) || '/pages/gift-builder';
  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
  var reduceM = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── market (AUD/GBP) ───────────────────────────────────────── */
  function getMarket() {
    try { return localStorage.getItem('ss-market') || 'aud'; } catch (e) { return 'aud'; }
  }
  function setMarket(m) {
    try { localStorage.setItem('ss-market', m); } catch (e) {}
    applyMarket(m);
  }
  function applyMarket(m) {
    var isGbp = m === 'gbp';
    $$('[data-aud]', document).forEach(function (n) { n.hidden = isGbp; });
    $$('[data-gbp]', document).forEach(function (n) { n.hidden = !isGbp; });
    $$('[data-market]', document).forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-market') === m);
    });
  }

  /* ── filter + BYO placement + editorial line ────────────────── */
  var byoInGrid = root.querySelector('[data-byo-ingrid]');
  var byoStandalone = root.querySelector('[data-byo-standalone]');
  var grid = root.querySelector('[data-grid]');
  var countEl = root.querySelector('[data-count]');
  var editorialEl = root.querySelector('[data-editorial]');

  var EDITORIAL = {
    comfort:  'For the friend who needs to feel held, not just heard.',
    her:      'For her - the considered ritual, posted slow on purpose.',
    him:      'For him - quiet luxuries, no fuss, no card-shop cliches.',
    birthday: 'A birthday box for someone who deserves more than a text.',
    moving:   'A taste of home, posted to the new postcode.',
    congrats: 'The chapter just turned. Mark it properly.'
  };

  function applyFilter(f) {
    var isAll = !f || f === 'all';
    var visible = 0;
    $$('[data-occ]').forEach(function (tile) {
      var occ = (tile.getAttribute('data-occ') || '').split(/\s+/);
      var match = isAll || occ.indexOf(f) !== -1;
      tile.style.display = match ? '' : 'none';
      if (match) visible++;
    });
    if (byoInGrid) byoInGrid.style.display = isAll ? '' : 'none';
    if (byoStandalone) byoStandalone.hidden = isAll;
    if (countEl) {
      countEl.textContent = visible + ' box' + (visible === 1 ? '' : 'es') + ' · most-loved first';
    }
    if (editorialEl) {
      var line = EDITORIAL[f];
      if (line && !isAll) {
        editorialEl.textContent = line;
        editorialEl.hidden = false;
        // next frame so the transition fires
        requestAnimationFrame(function () { editorialEl.classList.add('is-visible'); });
      } else {
        editorialEl.classList.remove('is-visible');
        editorialEl.hidden = true;
      }
    }
  }

  /* sticky-state toggle for filter bar (adds is-stuck once it pins) */
  var tools = root.querySelector('.lp-tools');
  if (tools && 'IntersectionObserver' in window) {
    // a 1px sentinel just above the tools - it leaves the viewport the moment
    // the tools start sticking
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:-1px;left:0;right:0;height:1px;pointer-events:none;';
    tools.style.position = 'sticky';
    tools.parentNode.insertBefore(sentinel, tools);
    new IntersectionObserver(function (entries) {
      tools.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }, { threshold: [0] }).observe(sentinel);
  }

  /* delivery bar: kept out of the fold until you are actually browsing.
     The hiding is opt-in via .is-auto so a dead script leaves the bar
     visible rather than hiding a conversion element permanently. */
  var dbar = document.querySelector('.ss-coll-all-bar');
  if (dbar) {
    dbar.classList.add('is-auto');
    var dbarOn = false;
    var dbarTick = function () {
      var on = window.scrollY > Math.max(280, window.innerHeight * 0.45);
      if (on !== dbarOn) { dbarOn = on; dbar.classList.toggle('is-revealed', on); }
    };
    window.addEventListener('scroll', dbarTick, { passive: true });
    dbarTick();
  }

  $$('[data-filter]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      $$('[data-filter]').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      applyFilter(btn.getAttribute('data-filter'));
    });
  });

  /* ── market toggle (page-level if header exposes it) ────────── */
  $$('[data-market]', document).forEach(function (b) {
    b.addEventListener('click', function () { setMarket(b.getAttribute('data-market')); });
  });
  applyMarket(getMarket());

  /* ── BYO builder cycle ──────────────────────────────────────── */
  var BMETA = [
    ['Step 1 of 2 - build the box', 'Hand-pick their <em>perfect box</em>', 'Choose a tier'],
    ['Step 1 of 2 - build the box', 'Fill it with <em>what you love</em>', 'Fill the box'],
    ['Step 2 of 2 - review',        'Almost there - <em>looks perfect</em>', 'Review &amp; send']
  ];
  function cycleByoc() {
    $$('.byoc', root).forEach(function (band) {
      var panels = $$('.panel', band);
      if (!panels.length) return;
      var step = $('.fs-step', band);
      var title = $('.fs-title', band);
      var pdots = $$('.pdots i', band);
      var cdots = $$('.stepcap .dots i', band);
      var cl = $('.stepcap .cl', band);
      var i = 0;
      function show(n) {
        panels.forEach(function (p, k) { p.classList.toggle('on', k === n); });
        if (step) step.textContent = BMETA[n][0];
        if (title) title.innerHTML = BMETA[n][1];
        if (cl) cl.innerHTML = '<b>' + BMETA[n][2].replace('&amp;', '&') + '</b>';
        cdots.forEach(function (d, k) { d.classList.toggle('on', k === n); });
        if (pdots[1]) pdots[1].classList.toggle('on', n === 2);
      }
      show(0);
      if (!reduceM) setInterval(function () { i = (i + 1) % 3; show(i); }, 2800);
    });
  }
  cycleByoc();

  /* ── image fade-in / kraft fallback ─────────────────────────── */
  $$('.lp-shot img, .ph2 img', root).forEach(function (img) {
    if (img.complete && img.naturalWidth > 0) {
      img.classList.add('is-loaded');
    } else {
      img.addEventListener('load', function () { img.classList.add('is-loaded'); });
      img.addEventListener('error', function () { img.remove(); });
    }
  });

  /* ── "Start building" deep-link ─────────────────────────────── */
  $$('[data-byo-cta]', root).forEach(function (a) {
    a.setAttribute('href', BYO_URL);
  });

  /* ── set initial filter ─────────────────────────────────────── */
  applyFilter('all');
})();
